<lvr-heading
	[showEditButton]="canEditInstitution()"
	(editClicked)="openEdit()"
	[ariaLabel]="'institution.edit.btn' | transloco"
>
	{{ 'institution.details.title' | transloco: { name: institution().name } }}
</lvr-heading>

@if (institution()) {
	<lvr-institution-details-view [institution]="institution()"></lvr-institution-details-view>
	<lvr-institution-activity [institutionId]="institution().id"></lvr-institution-activity>
}
